import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const TopRepsTable = ({ data, isLoading, error }) => {
  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  if (isLoading || !data) {
    return (
      <Skeleton
        variant="rectangular"
        height={400}
      />
    );
  }

  if (!data || data.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography color="textSecondary">No data available</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography
        variant="h6"
        sx={{ mb: 2 }}
      >
        Top Reps by Volume
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>Rank</TableCell>
              <TableCell>Rep Name</TableCell>
              <TableCell align="right"># Orders</TableCell>
              <TableCell align="right">Total $</TableCell>
              <TableCell align="right">Avg $</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={row._id}>
                <TableCell sx={{ fontWeight: "bold", width: 50 }}>
                  #{index + 1}
                </TableCell>
                <TableCell>{row.repName || "Unknown"}</TableCell>
                <TableCell align="right">{row.orderCount}</TableCell>
                <TableCell align="right">
                  $
                  {(row.totalValue || 0).toLocaleString("en-CA", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
                <TableCell align="right">
                  $
                  {(row.avgValue || 0).toLocaleString("en-CA", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TopRepsTable;
